/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifacts_Trash_Restore_ErrorInputs */



/**
* | output |
* | --- |
* | "The app could not be restored." |
*
* @param {Artifacts_Trash_Restore_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifacts_trash_restore_error = /** @type {((inputs?: Artifacts_Trash_Restore_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifacts_Trash_Restore_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die App konnte nicht wiederhergestellt werden.")
	return /** @type {LocalizedString} */ ("The app could not be restored.")
});